<script>
import lazyLoadComponent from '@router/lazyload-component'
import formatDate from '@utils/format-date'
import { paymentStatusMapFilter, bookingStatusFilter, orderStatusFilter } from '@utils/filter-value-to-text'

export default {
  filters: {
    formatDate,
    paymentStatusMapFilter,
    bookingStatusFilter,
    orderStatusFilter,
  },
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  props: {
    showAll: {
      type: Boolean,
      default: false,
    },
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit', 'goods'].includes(val)
      },
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    itemIndex: {
      type: [String, Number],
      required: true,
    },
    isChildren: {
      type: Boolean,
      default: false,
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false,
    },
    // 是否顯示未付款/已付款 for container
    showStateLabel: {
      type: Boolean,
      default: true,
    },
    // 是否顯示取消or刪除訂單
    showCancelOrDeleteBtn: {
      type: Boolean,
      default: true,
    },
    refundCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    /**
     * @description 看此訂單是否已經付錢
     */
    isPaid() {
      if (this.orderType === 'prepaid') {
        if (this.defaultValue.paidAt === null) {
          return false
        } else {
          return true
        }
      }
      return this.defaultValue.paymentStatus === 'PAID'
    },
    isInstallment() {
      return this.defaultValue.paymentMethod === 'Installment' ? true : false
    },
    // 卡單狀態以及子訂單不開放變更服務
    isTempOrderOrChildren() {
      return this.$store.state.modifyOrder.isTempOrder || this.isChildren
    },
    orderTitle() {
      return this.isChildren ? `子訂單` : `訂單`
    },
    orderId() {
      if (!this.defaultValue) {
        return ''
      }
      if (this.orderType === 'prepaid') {
        return `${this.defaultValue.orderNo}`
      }
      if (this.orderType === 'deposit') {
        return `${this.defaultValue.orderContainerDisplayId}`
      }
      // 當不是總訂單時，顯示這個id
      if (!this.showAll) {
        return this.defaultValue.id
      }
      return this.defaultValue.orderContainerDisplayId || this.defaultValue.displayId
    },
    cancelOrDeleteForReservationText() {
      if (this.defaultValue.status !== 0 && this.defaultValue.status !== 6 && this.defaultValue.orderContainerIsTemp === 0) {
        return '取消訂單'
      }
      if (this.defaultValue.status !== 0 && this.defaultValue.status !== 6 && this.defaultValue.orderContainerIsTemp === 1) {
        return '刪除訂單'
      }
      return ''
    },
  },
  methods: {
    handleCommand(command) {
      this[command]()
    },
    editOpenTotalEdit() {
      this.$emit('editOpenTotalEdit', this.itemIndex)
    },
    editOpenPaymentMethod() {
      this.$emit('editOpenPaymentMethod', this.itemIndex)
    },
    editOpenHistory() {
      this.$emit('editOpenHistory', this.itemIndex)
    },
    tryToCancelOrder() {
      this.$emit('emitContainerId')
      this.$emit('tryToCancelOrder', this.itemIndex)
    },
    /**
     * @description 退款(emit上去 TotalStatementDetail.vue)
     */
    editOpenRefund() {
      this.$emit('editOpenRefund', this.itemIndex)
    },
    openDeductHistory() {
      this.$emit('openDeductHistory', this.itemIndex)
    },
    modifyOrder() {
      this.$emit('modifyOrder')
    },
  },
}
</script>
<template>
  <div class="table__head" :class="{ isSetyleIsEmployee: isEmployee }" style="padding: 0">
    <div class="table__title" style="padding: 10px 0 10px 10px; width: 90%;">
      <div style="cursor: pointer" @click="$emit('clickDropDownIcon')">
        <BaseIcon style="font-size: 16px" :class="{ mobileHidden: isEmployee }" name="angle-down" class="align-middle mr-md-0 mr-2"></BaseIcon>
        <span class="mr-1 ml-0">{{ orderTitle }} {{ orderId }}</span>
        <template v-if="showAll">
          <BaseStateLabel v-if="defaultValue.cancel_at && showStateLabel" state="info" text>
            <span style="font-size:12px">已取消</span>
          </BaseStateLabel>
          <BaseStateLabel v-else-if="defaultValue.paymentStatus === 'UNPAID' && showStateLabel" state="danger" text>
            <span style="font-size:12px">未付款</span>
          </BaseStateLabel>
          <BaseStateLabel v-else-if="defaultValue.paymentStatus === 'PAID' && showStateLabel" state="success" text>
            <span style="font-size:12px">已付款</span>
          </BaseStateLabel>
        </template>
        <template v-else>
          <template v-if="defaultValue.status === 0">
            <BaseStateLabel v-if="showStateLabel" state="info" text>
              <span style="font-size:12px">{{ defaultValue.status | bookingStatusFilter('text') }}</span>
            </BaseStateLabel>
          </template>
          <template v-else>
            <template v-if="(orderType === 'reservation' || orderType === 'goods') && showStateLabel">
              <BaseStateLabel :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')" text>
                <span style="font-size:12px">{{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}</span>
              </BaseStateLabel>
            </template>
            <template v-if="orderType === 'prepaid' && showStateLabel">
              <BaseStateLabel :state="defaultValue.status | orderStatusFilter('color')" text>
                <span style="font-size:12px">{{ defaultValue.status | orderStatusFilter('text') }}</span>
              </BaseStateLabel>
            </template>
            <template v-if="orderType === 'deposit' && showStateLabel">
              <BaseStateLabel :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')" text>
                <span style="font-size:12px">{{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}</span>
              </BaseStateLabel>
            </template>
          </template>
        </template>
      </div>
    </div>
    <div class="table__single" style="width: 35px; align-self: center;">
      <!-- 訂單計算下拉選單 -->
      <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
        <div style="cursor: pointer; padding: 10px; width: 20%" @click.stop="$refs.more && $refs.more.show()">
          <BaseIcon style="font-size: 16px" name="ellipsis-v"></BaseIcon>
        </div>
        <el-dropdown-menu slot="dropdown">
          <template v-if="orderType === 'reservation' && !isEmployee">
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isInstallment && !isPaid" command="editOpenTotalEdit">編輯價格與折扣</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isPaid && showAll && false" command="editOpenPaymentMethod">編輯付款方式</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isInstallment && !isPaid && !isTempOrderOrChildren && !showAll" command="modifyOrder">變更服務</el-dropdown-item>
            <el-dropdown-item command="editOpenHistory">訂單變更記錄</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0 && defaultValue.status !== 6 && showCancelOrDeleteBtn" command="tryToCancelOrder">{{
              cancelOrDeleteForReservationText
            }}</el-dropdown-item>
            <el-dropdown-item v-if="isPaid && defaultValue.paymentMethod !== 'Prepaid' && showAll" command="editOpenRefund">退款</el-dropdown-item>
          </template>
          <!-- Employee -->
          <template v-if="orderType === 'reservation' && isEmployee">
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isInstallment && !isPaid" command="editOpenTotalEdit">編輯加購</el-dropdown-item>
            <el-dropdown-item command="editOpenHistory">訂單變更記錄</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0 && defaultValue.status !== 6 && isChildren" command="tryToCancelOrder">{{ cancelOrDeleteForReservationText }}</el-dropdown-item>
          </template>
          <template v-if="orderType === 'goods'">
            <!-- <el-dropdown-item v-if="defaultValue.status !== 0"
              command="editOpenTotalEdit">編輯價格與運費</el-dropdown-item> -->
            <el-dropdown-item command="editOpenHistory">訂單變更記錄</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0" command="tryToCancelOrder">取消訂單</el-dropdown-item>
            <el-dropdown-item v-if="isPaid && refundCheck" command="editOpenRefund">退款</el-dropdown-item>
          </template>
          <template v-if="orderType === 'prepaid'">
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isInstallment && !isPaid" command="editOpenTotalEdit">編輯價格與折扣</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isInstallment && !isPaid" command="editOpenPaymentMethod">編輯付款方式</el-dropdown-item>
            <el-dropdown-item command="openDeductHistory">客戶使用歷程</el-dropdown-item>
            <el-dropdown-item command="editOpenHistory">訂單變更記錄</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0" command="tryToCancelOrder">取消訂單</el-dropdown-item>
            <el-dropdown-item v-if="isPaid" command="editOpenRefund">退款</el-dropdown-item>
          </template>
          <template v-if="orderType === 'deposit'">
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isInstallment && !isPaid" command="editOpenPaymentMethod">編輯付款方式</el-dropdown-item>
            <el-dropdown-item command="editOpenHistory">訂單變更記錄</el-dropdown-item>
            <el-dropdown-item v-if="defaultValue.status !== 0 && !isPaid" command="tryToCancelOrder">取消訂單</el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<style lang="scss" module></style>
